import './googleAnalytics';
import './googleTagManager';

import Raven from 'raven-js';

import { getCurrentBreakpoint } from '@opendoor/shared-fe/build/mediaBreakpoints';

import { EventTrackingFn } from '../declarations';
import { RAILS_ENV } from '../helpers/globals';
import { isQuotaExceededError } from '../helpers/isQuotaExceededError';
import segment from './segment';

/* eslint-disable */
// Linter doesn't like the way we're just calling functions without defining them ourselves
declare var ga: any;
declare var window: any;

const wrapQuotaError = cb => {
  try {
    cb();
  } catch (e) {
    if (!isQuotaExceededError(e)) {
      Raven.captureException(e);
    }
  }
};

export const register = traits => {
  if (typeof ga === 'function' && typeof traits === 'object') {
    ga('set', traits);
  }
  segment.identify(traits);
  if (RAILS_ENV !== 'production') {
    // tslint:disable-next-line
    console.debug(`[DEBUG] Analytics.identify: \n${JSON.stringify(traits, null, 2)}`);
  }
};

export const trackEvent: EventTrackingFn = (category, action, label, extra) => {
  // Have to copy-paste the try/catch because doing try/catch functionally
  // with generators is complicated
  wrapQuotaError(() => {
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/events
    if (typeof ga === 'function') {
      ga('send', 'event', category, action, label, extra);
    }
  });

  wrapQuotaError(() => {
    // https://segment.com/docs/spec/track/
    segment.track(`${category}-${action}`, {
      channel: 'web',
      domain: window.location.host,
      screen: {
        height: window.screen.height,
        width: window.screen.width,
      },
      value: label,
      viewport: getCurrentBreakpoint(),
      ...extra,
    });
  });

  wrapQuotaError(() => {
    // https://support.google.com/tagmanager/answer/6106961?hl=en
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `${category}.${action}.${label}`, extra });
  });

  if (RAILS_ENV !== 'production') {
    // tslint:disable-next-line
    console.debug(
      `[DEBUG] Analytics.trackEvent: \n${category}-${action} ${JSON.stringify(
        {
          value: label,
          ...extra,
        },
        null,
        2,
      )}`,
    );
  }
};
